import * as React from 'react';

export const COUPON_DISCOUNT_TYPE_AMOUNT = '2';
export const COUPON_DISCOUNT_TYPE_PERCENTAGE = '1';
